document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (toggle && menu) toggle.addEventListener('click', () => menu.classList.toggle('is-open'));
  const header = document.querySelector('[data-sticky-header]');
  window.addEventListener('scroll', () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  });
});